import { Dispatch, SetStateAction, useState } from "react";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import {
    faPaperPlane,
    faPaperclip,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { ResponderEmailAnexoController } from "../../../../Controllers/Geral/Email/EmailController";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { IGestaoTriagem } from "../../../../Interfaces/Geral/Triagem";
import { AlertWarning } from "../../../../Tools/SweetAlerts";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ListarEmailContaPorUsuarioController } from "../../../../Controllers/Geral/Grupos/GruposEmailsController";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import CreatableSelect from "react-select/creatable";
import { ActionMeta, MultiValue } from "react-select";

interface htmlQuill {
    editorHtml: string;
}

interface EmailOption {
    value: string;
    label: string;
}

interface IResponderEmail {
    DS_ASSUNTO: string;
    DS_COPIA_CARBONO: string;
    DS_REMETENTE: string;
    ID_EMAIL: number;
    ID_EMAIL_CONTA: number;
    updateTriagem: (...args: any[]) => Promise<IGestaoTriagem>;
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function ResponderEmail(props: IResponderEmail) {
    const [LstDocs, setLstDocs] = useState<Array<File>>();
    const [copiaCarbono, setCopiaCarbono] = useState<string>(
        props.DS_COPIA_CARBONO
    );

    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);

    const formMethods = useForm();

    const { register, handleSubmit, formState } = formMethods;

    const { execute: EnviarEmail, loading: EnviarEmailLoading } =
        useAsyncCallback(ResponderEmailAnexoController);

    const {
        value: LstEmailContaPorUsuario,
        loading: LstEmailContaPorUsuarioLoading,
    } = useAsyncEffect(ListarEmailContaPorUsuarioController);

    function handleEnviarEmail(formData: any) {
        EnviarEmail(props.ID_EMAIL, {
            File: LstDocs,
            DS_ASSUNTO: props.DS_ASSUNTO,
            DS_MENSAGEM: convertedText.editorHtml,
            ID_CASO: 0,
            ID_EMAIL_CONTA: formData.ID_EMAIL_CONTA,
            DS_DESTINATARIO: formData.destinatario,
            DS_COPIA_CARBONO: copiaCarbono,
            DS_COPIA_CARBONO_OCULTA: formData.DS_COPIA_CARBONO_OCULTA,
        }).then(() => {
            props.setShow(false);
            props.updateTriagem();
        });
    }

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
        }),
    };

    const getEmailOptions = (emails: string) => {
        return emails
            .split(";")
            .filter((email: string) => email)
            .map((email: string) => ({ value: email, label: email }));
    };

    const handleChangeCopiaCarbono = (
        selectedOptions: MultiValue<EmailOption>,
        actionMeta: ActionMeta<EmailOption>
    ) => {
        const emailString = selectedOptions
            .map((option) => option.value)
            .join(";");
        setCopiaCarbono(emailString);
    };

    const defaultEmailOptions = getEmailOptions(props.DS_COPIA_CARBONO);
    const selectedEmailOptions = getEmailOptions(copiaCarbono);
    const combinedOptions = Array.from(
        new Set(
            [...defaultEmailOptions, ...selectedEmailOptions].map(
                (opt) => opt.value
            )
        )
    ).map((value) => ({ value, label: value }));

    return (
        <OrSpinner loading={LstEmailContaPorUsuarioLoading} spinner="capys">
            <form onSubmit={handleSubmit(handleEnviarEmail)}>
                <div className="row d-flex flex-wrap mb-3">
                    <div className="col-12 col-lg-6 mt-2">
                        <label>Email Remetente:</label>
                        <select
                            name="ID_EMAIL_CONTA"
                            className={`form-control placeholder-dark-50  ${
                                formState.errors.email_remetente && "is-invalid"
                            }`}
                            ref={register({
                                required: "Insira o email",
                                valueAsNumber: true,
                            })}
                        >
                            {LstEmailContaPorUsuario &&
                                LstEmailContaPorUsuario.map((email) => {
                                    return (
                                        <option
                                            key={email.ID_EMAIL_CONTA}
                                            value={email.ID_EMAIL_CONTA}
                                        >
                                            {email.DS_REMETENTE}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <label>Email Destinatário:</label>
                        <input
                            type="text"
                            name="destinatario"
                            placeholder="Destinatário:"
                            autoComplete="off"
                            className={`form-control px-0 p-2 placeholder-muted-75 ${
                                formState.errors.assunto && "is-invalid"
                            }`}
                            defaultValue={props.DS_REMETENTE}
                            ref={register({
                                required: "Insira o email destinatário",
                            })}
                        />
                    </div>
                </div>
                <div className="row mb-3 d-flex flex-wrap">
                    <div className="col-12 col-lg-6 mt-2">
                        <label>Cópia Carbono:</label>
                        <CreatableSelect
                            isMulti
                            isClearable
                            isSearchable
                            onChange={handleChangeCopiaCarbono}
                            formatCreateLabel={(value) =>
                                `Clique para selecionar: ${value}`
                            }
                            styles={customStyles}
                            placeholder={"Digite o email para cópia"}
                            options={combinedOptions}
                            value={selectedEmailOptions}
                            className="Select-menu-outer"
                        />
                    </div>

                    <div className="col-12 col-lg-6 mt-2">
                        <label>Cópia Carbono Oculta:</label>
                        <input
                            type="email"
                            name="DS_COPIA_CARBONO_OCULTA"
                            placeholder={"Digite o email para cópia oculta"}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            ref={register()}
                        />
                    </div>
                </div>
                <div className="row mb-3 d-flex flex-wrap">
                    <div className="col-12 col-lg-11">
                        <input
                            type="text"
                            name="assunto"
                            placeholder="Assunto:"
                            autoComplete="off"
                            className={`form-control px-0 p-2 placeholder-muted-75 ${
                                formState.errors.assunto && "is-invalid"
                            }`}
                            defaultValue={`RE: ${props.DS_ASSUNTO}`}
                            readOnly
                        />
                    </div>
                    <div className="col-12 col-lg-1 btn btn-clean btn-icon btn-md ">
                        <label
                            htmlFor="file_input_enviar_email"
                            className="m-0"
                        >
                            Anexo:{" "}
                            <FontAwesomeIcon
                                icon={faPaperclip}
                                className="ml-1 mr-1"
                                size="lg"
                            />
                        </label>
                        <input
                            type="file"
                            multiple
                            name="file"
                            id="file_input_enviar_email"
                            className="d-none"
                            onChange={async (e) => {
                                const docs: Array<File> = Array.from(
                                    LstDocs || []
                                );

                                for (
                                    let index = 0;
                                    index < (e.target.files?.length || 0);
                                    index++
                                ) {
                                    const element = e.target.files?.item(index);
                                    if (element && element.size > 10_000_000)
                                        // arquivo não pode ser maior que 10MB
                                        await AlertWarning(
                                            "Não foi possível anexar o arquivo!",
                                            `O arquivo ${element.name} não pode ser enviado por e-mail pois ele é maior que 10MB`
                                        );
                                    else if (element) docs.push(element);
                                }
                                setLstDocs(docs);
                            }}
                            ref={register()}
                        />
                    </div>
                    {LstDocs && LstDocs.length > 0 ? (
                        LstDocs.map((arquivo: File, index) => {
                            return (
                                <div
                                    key={index}
                                    className="d-flex flex-wrap justify-content-between ml-1"
                                >
                                    <div
                                        className="btn btn-clean col-12 col-lg-12 d-flex justify-content-between mt-2 ml-2"
                                        onClick={() => {
                                            setLstDocs(
                                                LstDocs.filter(
                                                    (doc) =>
                                                        doc.name !==
                                                        arquivo.name
                                                )
                                            );
                                        }}
                                    >
                                        {arquivo.name.length > 20
                                            ? arquivo.name.substr(0, 20) + "..."
                                            : arquivo.name}
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            className="text-danger ml-2"
                                        />
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div></div>
                    )}
                </div>

                <div className="mb-8">
                    <div className=" w-100 h-100">
                        <FroalaEditor
                            onChange={(e) => {
                                handleChange(e);
                            }}
                            value={convertedText.editorHtml || ""}
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <button
                        type="submit"
                        className="btn btn-success"
                        disabled={EnviarEmailLoading}
                    >
                        {EnviarEmailLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon
                                icon={faPaperPlane}
                                size="sm"
                                className="mr-2"
                            />
                        )}{" "}
                        Enviar
                    </button>
                </div>
            </form>
        </OrSpinner>
    );
}
